import { render } from "./Rebaixas.vue?vue&type=template&id=a55d9076&scoped=true"
import script from "./Rebaixas.vue?vue&type=script&lang=js"
export * from "./Rebaixas.vue?vue&type=script&lang=js"

import "./Rebaixas.vue?vue&type=style&index=0&id=a55d9076&lang=scss&scoped=true"

import exportComponent from "D:\\Projetos\\Git\\MINUS\\Sites\\site-gerencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a55d9076"]])

export default __exports__